import React, { Suspense, useState, useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import {
  App,
  styled,
  Block,
  createGlobalStyle,
  ProgressBarStyles,
} from "../seenspire-library";
import { Header, PoweredBy } from "./components";
import Routes, { RoutesConfig } from "./routes";
import { Provider, Consumer, IAppContext, useAppContext } from "./state";
import { AppMenu } from "./components/AppMenu/AppMenu";
import ConfirmEmailModal from "./modals/ConfirmEmailModal";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import ErrorNotificationModal from "./modals/ErrorNotificationModal";
import NotificationModal from "./modals/NotificationModal";
import RequestFeatureModal from "./modals/RequestFeatureModal";
import SwitchAccountModal from "./modals/SwitchAccountModal";
import StickyNotification from "./components/StickyNotification/StickyNotification";
import DeleteFeedModal from "./modals/DeleteFeedModal";
import AcceptTermsModal from "./modals/AcceptTermsModal";
import RequestTrialModal from "./modals/RequestTrialModal";
import { RequestTrialEndedModal } from "./modals/RequestTrialModal/RequestTrialEndedModal";
import { ContinueOnDesktopGate } from "./containers/ContinueOnDesktop/ContinueOnDesktopGate";
import { useMedia } from "../app/util";

const AppGlobalStyles = createGlobalStyle`
  html, body, #root {
    height:100%;
    overflow: hidden;
  }
  #root {
    display:flex;
    flex-direction:column;
    overflow-y: auto;
  }
  body{
    overflow-x: hidden;
    line-height: normal;
  }
  .uppy-Dashboard-AddFiles {
    border: none !important;
  }

  .uppy-Dashboard-AddFiles-list {
    flex: none !important;
  }
  .uppy-Dashboard-AddFiles-title {
    font-size: 16px !important;
    font-weight: 600 !important;
    line-height: 16px !important;
    letter-spacing: -0.145px !important;
    text-align: center;
  }
  .uppy-Dashboard-inner {
    border: none !important;
  }
`;

const RouteContainer = styled(Block)`
  flex: 1;
`;

const Index = () => {

  return (
    <Router>
      <DndProvider backend={HTML5Backend}>
        <Provider>
          <Consumer>
            {(context: IAppContext) => (
              <App theme={context.theme}>
                  {/* Its copy is translated, so it suspends until the
                      locale bundle has loaded. */}
                  <Suspense fallback={null}>
                    <ContinueOnDesktopGate />
                  </Suspense>
                  <AppGlobalStyles />
                  <ProgressBarStyles />
                  <Suspense fallback={<></>}>
                    <StickyNotification />
                    <Header />
                    <AppMenu />
                  </Suspense>
                  <Suspense fallback={null}>
                    <RouteContainer>
                      <Routes routesConfig={RoutesConfig} />
                    </RouteContainer>
                    <NotificationModal isOpen={true} />
                    <ConfirmEmailModal isOpen={true} />
                    <AcceptTermsModal isOpen={true} />
                    <RequestFeatureModal isOpen={true} />
                    <RequestTrialModal isOpen={true} />
                    <RequestTrialEndedModal isOpen={true} />
                    <SwitchAccountModal isOpen={true} />
                    <DeleteFeedModal />
                    {context.showPoweredBy && <PoweredBy />}
                    <ErrorNotificationModal
                      error={context.error}
                      setError={context.setError}
                    />
                  </Suspense>
                </App>
            )}
          </Consumer>
        </Provider>
      </DndProvider>
    </Router>
  );
};

export default Index;
